import { ChatUiVariants } from '@trimble-agentic-external-npm-local/agentic-platform-sdk-iframe-typescript';
import { useEffect } from 'react';

import { EmbeddedFullChat } from './EmbeddedFullChat';
import { EmbeddedMinimalChat } from './EmbeddedMinimalChat';
import { EmbeddedNarrowChat } from './EmbeddedNarrowChat';
import { useEmbeddedConfig } from '../providers/embedded-config-provider';
import { trackEmbeddedOpenedOnce } from '../utilities/embeddedAnalytics';

const isNarrowVariant = (
  variant: ChatUiVariants | 'narrow'
): variant is 'narrow' => variant === 'narrow';

export const EmbeddingPageFactory = () => {
  const { chatConfig } = useEmbeddedConfig();

  useEffect(() => {
    trackEmbeddedOpenedOnce(chatConfig);
  }, [chatConfig]);

  if (isNarrowVariant(chatConfig.uiConfig.variant)) {
    return <EmbeddedNarrowChat />;
  }
  if (chatConfig.uiConfig.variant === ChatUiVariants.Minimal) {
    return <EmbeddedMinimalChat />;
  }
  return <EmbeddedFullChat />;
};
